import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

// Components
import BidJsScripts from './bidJsScripts'
import CookiePreferencesBanner from './cookiePreferences'
import Header from './header'
import Footer from './footer'

const layoutQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`

const Layout = ({ children, lang, path, location }) => {
  return (
    <StaticQuery
      query={`${layoutQuery}`}
      render={(data) => (
        <div className='min-h-screen layout flex flex-col bg-brand-blue tracking-tight text-gray-700 antialiased'>
          <Header lang={lang} />
          <main role='main' id='main' className='mt-28'>
            {children}
          </main>
          <Footer lang={lang} />
          <CookiePreferencesBanner location={location} />
          <BidJsScripts path={path} />
        </div>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  lang: PropTypes.string,
  path: PropTypes.string,
  location: PropTypes.object
}

export default Layout
